import './App.css';

import './App.jsx';
import React, { useEffect } from 'react';
import ProtectedRoutes from './pageauth/ProtectedRoutes.jsx';
import { LayoutClient } from './layouts/LayoutClient.jsx';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { LayoutHome, LayoutHomeLogo } from './layouts/LayoutHome.jsx';
import Mensaje from './Mensaje.jsx';
import Error404 from "./Error404.jsx";
import { CuerpoHomePlaya } from './componentes/Cuerpos/playa/HomePlaya.jsx';
import { CuerpoHomeShop } from './componentes/Cuerpos/shop/HomeShop.jsx';
import { CuerpoHomeRemoteWork } from './componentes/Cuerpos/remotework/HomeRemoteWork.jsx';
import { LayoutClientRemoteWork } from './layouts/LayoutClientRemoteWork.jsx';
import { RW_Config_Modulos } from './componentes/Cuerpos/remotework/submodulos/Configuracion/modulos/RW_Config_Modulos.jsx';
import { RW_Config_Modulos_Agregar } from './componentes/Cuerpos/remotework/submodulos/Configuracion/modulos/RW_Config_Modulos_Agregar.jsx';
import { RW_Config_Modulos_Configurar } from './componentes/Cuerpos/remotework/submodulos/Configuracion/modulos/RW_Config_Modulos_Configurar.jsx';
import { RW_Combustibles_Combustibles } from './componentes/Cuerpos/remotework/submodulos/Combustibles/RW_Combustibles_Combustibles.jsx';
import { RW_Combustibles_Tanques } from './componentes/Cuerpos/remotework/submodulos/Combustibles/RW_Combustibles_Tanques.jsx';
import { RW_Usuarios } from './componentes/Cuerpos/remotework/submodulos/Usuarios/RW_Usuarios.jsx';
import { RW_Empleados } from './componentes/Cuerpos/remotework/submodulos/Empleados/RW_Empleados.jsx';
import { RW_Clientes } from './componentes/Cuerpos/remotework/submodulos/Clientes/RW_Clientes.jsx';
import { RW_Proveedores } from './componentes/Cuerpos/remotework/submodulos/Proveedores/RW_Proveedores.jsx';
import { RW_Playa } from './componentes/Cuerpos/remotework/submodulos/PlayaMini/RW_Playa.jsx';
import { RW_Minimercado } from './componentes/Cuerpos/remotework/submodulos/PlayaMini/RW_Minimercado.jsx';
import { RW_Config_RazonesSociales } from './componentes/Cuerpos/remotework/submodulos/Configuracion/razonessociales/RW_Config_RazonesSociales.jsx';

function compareVersions(v1, v2) {
    const a = v1.split('.').map(Number);
    const b = v2.split('.').map(Number);
    for (let i = 0; i < Math.max(a.length, b.length); i++) {
        const diff = (a[i] || 0) - (b[i] || 0);
        if (diff !== 0) return diff;
    }
    return 0;
}

function App() {

    const { SetMensaje } = Mensaje();
    return (
        <Router>
            <Routes>
                <Route path="/" element={<LayoutHome />}>
                </Route>

                <Route element={<ProtectedRoutes />}>
                    <Route path="/playa" element={<LayoutClient />}>
                        <Route index element={<CuerpoHomePlaya />} />
                    </Route>

                    <Route path="/shop" element={<LayoutClient />}>
                        <Route index element={<CuerpoHomeShop />} />
                    </Route>

                    <Route path="/remotework" element={<LayoutClientRemoteWork />}>
                        <Route index element={<CuerpoHomeRemoteWork />} />
                    </Route>

                    <Route path="/remotework/configuracion/modulos" element={<LayoutClientRemoteWork />}>
                        <Route index element={<RW_Config_Modulos />} />
                    </Route>

                    <Route path="/remotework/configuracion/modulos/agregar" element={<LayoutClientRemoteWork />}>
                        <Route index element={<RW_Config_Modulos_Agregar />} />
                    </Route>

                    <Route path="/remotework/configuracion/modulos/configurar" element={<LayoutClientRemoteWork />}>
                        <Route index element={<RW_Config_Modulos_Configurar />} />
                    </Route>

                    <Route path="/remotework/configuracion/razonessociales" element={<LayoutClientRemoteWork />}>
                        <Route index element={<RW_Config_RazonesSociales />} />
                    </Route>

                    <Route path="/remotework/combustibles/combustibles" element={<LayoutClientRemoteWork />}>
                        <Route index element={<RW_Combustibles_Combustibles />} />
                    </Route>

                    <Route path="/remotework/combustibles/tanques" element={<LayoutClientRemoteWork />}>
                        <Route index element={<RW_Combustibles_Tanques />} />
                    </Route>

                    <Route path="/remotework/usuarios" element={<LayoutClientRemoteWork />}>
                        <Route index element={<RW_Usuarios />} />
                    </Route>

                    <Route path="/remotework/empleados" element={<LayoutClientRemoteWork />}>
                        <Route index element={<RW_Empleados />} />
                    </Route>

                    <Route path="/remotework/clientes" element={<LayoutClientRemoteWork />}>
                        <Route index element={<RW_Clientes />} />
                    </Route>

                    <Route path="/remotework/proveedores/administrar" element={<LayoutClientRemoteWork />}>
                        <Route index element={<RW_Proveedores />} />
                    </Route>
                    <Route path="/remotework/proveedores/contable" element={<LayoutClientRemoteWork />}>
                        <Route index element={<RW_Proveedores />} />
                    </Route>

                    <Route path="/remotework/playamini/playa" element={<LayoutClientRemoteWork />}>
                        <Route index element={<RW_Playa />} />
                    </Route>

                    <Route path="/remotework/playamini/minimercado" element={<LayoutClientRemoteWork />}>
                        <Route index element={<RW_Minimercado />} />
                    </Route>

                </Route>
                <Route path="*" element={<Error404 />} />
            </Routes>
        </Router>
    );
}

export default App;

